import { Amcharts } from "./Amcharts";
import * as am4plugins_wordCloud from "@amcharts/amcharts4/plugins/wordCloud"; 

export class AmchartsWordCloudchart extends Amcharts {
    createByRef(ref: any, context: any) : any {
        context.settings.themeVariant = context.settings.themeVariant || 3;
        this.create(ref, am4plugins_wordCloud.WordCloud, context);
        this.applyTheme(context);
        this.createSeries(context);
        this.setData(context);
        return this;
    }

    //recreate(ref: any, context: any) {
    //    this.dispose();
    //    this.createByRef(ref, context);
    //}

    createSeries(context: any) {
        let series = this.chart.series.push(new am4plugins_wordCloud.WordCloudSeries());
        if (context.measures.length != 0 && context.dimensions.length != 0) {
            series.dataFields.word = context.dimensions[0].resultName;
            series.dataFields.value = context.measures[0].resultName;
        }
    }

    setData(context: any) {
        if (!context?.data) {
            this.clearData();
            return;
        }

        const series = this.chart.series.values[0];
        if (!context.wordIsDateTime || !context.wordDateFormat || !context.wordFieldName) {
            series.data = context.data;
            return;
        }

        const lang =
            context.applicationLanguage?.length
                ? context.applicationLanguage
                : (navigator.languages?.[0] ?? navigator.language ?? "en");

        const formatter = new Intl.DateTimeFormat(lang, context.wordDateFormat);
        const fieldName = context.wordFieldName;
        const mapped = context.data.map((row: any) => {
            const raw = row?.[fieldName];
            if (!raw) return row;

            const date = new Date(raw);
            if (Number.isNaN(date.getTime())) return row;

            return { ...row, [fieldName]: formatter.format(date) };
        });

        series.data = mapped;

    }
}